import {styled} from "styled-components";

const HideableCellValue = styled.div<{hide: boolean; maxHeight?: string}>`
  width: 100%;
  max-height: ${({maxHeight}) => maxHeight ?? "10em"};
  overflow: ${({hide}) => (hide ? "hidden" : "auto")};

  ${({hide}) =>
    hide &&
    `
      white-space: nowrap;
      text-overflow: ellipsis;
      color: grey;
    `}
`;

export default HideableCellValue;
